import React from "react"
import { Button, ButtonToolbar } from "react-bootstrap"
import { BootstrapTable } from "react-bootstrap-table"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import authServerConstans from "../../../redux/sagas/authServerConstans"
import CheckUserActivity from "./CheckUserActivity"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

class UserTable extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  options = {
    sortName: 'id',
    sortOrder: 'desc',
  }

  constructor(props) {

    super(props)
    this.state = {
      showRemoveModal: false,
      itemSelected: false,
      selectedRow: { id: null },
      selectRowProp: {
        mode: "radio",
        clickToSelect: true,
        hideSelectColumn: true,
        bgColor: "#9bbfdd",
        onSelect: this.onRowSelect
      },
      checkActivityRunning: false,
      checkActivityError: '',
      activity: 0,
      nbLoan: 0,
    }
  }

  onRowSelect = (row, isSelected, e) => {
    if (isSelected === true) {
      this.setState({ selectedRow: row })
      this.props.selectedHandler(row.id)
    }
    this.setState({ itemSelected: isSelected })
  }

  getSelectedItems() {
    let itemsArray = []
    itemsArray.push(this.state.selectedRow)
    return itemsArray
  }

  closeRemoveModal = () => this.setState({ 
    showRemoveModal: false,
  })

  showRemoveDialog = () => this.setState({ 
    activity: 0,
    showRemoveModal: true,
  })

  /**
   * Count loans assigned to user
   */
  processRemoveUser = () => {

    this.showRemoveDialog()

    this.setState({
      checkActivityRunning: true,
      checkActivityError: '',
    })

    blockingFetchService(
      accessToken => apiServerApi.countLoansForUser(accessToken, this.getUserToRemove().username), 
      nbLoan => this.countLoansSuccess(nbLoan),
      error => this.countLoansFailure(error),
      () => {}
    )
  }

  countLoansSuccess = nbLoan => this.setState({
    checkActivityRunning: false,
    checkActivityError: '',
    activity: nbLoan > 0 ? 1 : 2,
    nbLoan,
  })

  countLoansFailure = error => this.setState({
    checkActivityRunning: false,
    checkActivityError: error.text,
  })

  /**
   * Change loans assignment from one user to another
   * 
   * @param {*} fromUsername 
   * @param {*} toUsername 
   */
  assignToUsername = (fromUsername, toUsername) => {

    this.setState({
      checkActivityRunning: true,
      checkActivityError: '',
    })

    blockingFetchService(
      accessToken => apiServerApi.changeLoanAssignee(accessToken, fromUsername, toUsername), 
      response => this.changeAssigneeSuccess(response),
      error => this.changeAssigneeFailure(error),
      () => {}
    )
  }

  changeAssigneeSuccess = () => this.setState({
    checkActivityRunning: false,
    checkActivityError: '',
    activity: 2,
  })

  changeAssigneeFailure = error => this.setState({
    checkActivityRunning: false,
    checkActivityError: error.text,
  })

  confirmRemoval = () => {
    const ids = this.getSelectedItems().map(x => x.id)
    this.props.onConfirmRemoval(ids)
    this.closeRemoveModal()
    this.setState({ itemSelected: {} })
  }

  getItemsToRemove = () => this.getSelectedItems().map(item => this.props.renderItemToRemove(item))

  getUserToRemove = () => this.state.selectedRow

  canRemoveThisAccount = () => {

    const { selectedRow } = this.state
  
    if(this.isAdmin && selectedRow.userRole === authServerConstans.adminRoleName) {
      const { items: users } = this.props
      let nbAdmin = 0
      for (let i = 0; i < users.length; i++) {
        if( users[i].userRole === authServerConstans.adminRoleName) {
          nbAdmin++
        }
      }
      return !(nbAdmin === 1)
    }

    return true
  }

  renderContent() {

    const { items, children, addNewHandler, addNewLabel } = this.props,
    { selectRowProp, itemSelected, showRemoveModal, checkActivityRunning, checkActivityError,
      activity, nbLoan } = this.state

    return (
      <div>

        <BootstrapTable
          data={ items }
          striped
          hover
          condensed
          pagination
          exportCSV={ this.isAdmin }
          csvFileName='Users.csv'
          selectRow={ selectRowProp }
          options={ this.options }
        >
          { children }
        </BootstrapTable>

        <ButtonToolbar className="tableToolbar">

          <Button 
            bsStyle="primary"
            title='Create a new user'
            onClick={ addNewHandler }>
            <FontAwesome name='plus-circle' /> { addNewLabel }
          </Button>

          <Button
            bsStyle="danger"
            onClick={ this.processRemoveUser }
            title='Remove user and all their activities'
            disabled={ !itemSelected || !this.canRemoveThisAccount()}>
            <FontAwesome name='trash-o' /> Remove selected
          </Button>
        </ButtonToolbar>

        <CheckUserActivity
          user={ this.getUserToRemove() }
          show={ showRemoveModal }
          close={ this.closeRemoveModal }
          confirmRemoval={ this.confirmRemoval }
          activityRunning={ checkActivityRunning }
          activityError={ checkActivityError }
          activity={ activity }
          nbLoan={ nbLoan }
          assignToUsername={ this.assignToUsername }
        />
      </div>
    )
  }

  render() {
    return (
      this.props.loading ? <p>Loading...</p> : this.renderContent()
    )
  }
}

export default UserTable



// WEBPACK FOOTER //
// ./src/components/Users/UserTable/index.js